var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFiv(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 530,
    height: 530,
    viewBox: "0 0 530 530",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 530,
    height: 530,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M226.313 260.458C231.464 269.38 229.876 279.941 220.954 285.092C212.031 290.244 202.091 286.339 196.94 277.417C191.789 268.495 195.691 256.598 202.3 252.783C208.908 248.967 221.162 251.536 226.313 260.458Z",
    fill: "#1C1B1F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M304.321 260.458C299.17 269.38 300.758 279.941 309.68 285.092C318.602 290.244 328.542 286.339 333.693 277.417C338.845 268.495 334.943 256.598 328.334 252.783C321.725 248.967 309.472 251.536 304.321 260.458Z",
    fill: "#1C1B1F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M214.348 371.196C218.72 370.581 229.543 371.688 237.851 381.035C242.223 386.979 256.107 393.333 276.658 371.196C280.484 367.712 290.76 364.801 301.254 381.035C303.826 385.012 308.36 390.381 321.478 383.495",
    stroke: "#1C1B1F",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M154.596 188.651C130.721 197.815 82.2564 230.008 79.3915 285.47C83.7684 282.283 94.4323 277.82 102.072 285.47C91.7265 304.993 72.7066 348.104 79.3915 364.36C83.7687 362.766 93.4781 360.535 97.2976 364.36C102.072 369.141 80.5856 382.289 88.9416 405C93.7165 398.625 105.654 387.787 115.203 395.437",
    stroke: "#1C1B1F",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M197.596 171.182C179.438 152.601 137.235 119.251 106.34 125.852C103.198 126.523 101.675 129.886 102.626 132.955C109.771 156.007 118.211 197.514 112.266 214.855",
    stroke: "#1C1B1F",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M376.32 188.651C400.195 197.815 448.66 230.008 451.525 285.47C447.148 282.283 436.484 277.82 428.844 285.47C439.189 304.993 458.209 348.104 451.525 364.36C447.147 362.766 437.438 360.535 433.618 364.36C428.844 369.141 450.33 382.289 441.974 405C437.2 398.625 425.262 387.787 415.713 395.437",
    stroke: "#1C1B1F",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M333.32 171.182C351.478 152.601 393.681 119.251 424.576 125.852C427.718 126.523 429.241 129.886 428.29 132.955C421.145 156.007 412.705 197.514 418.65 214.855",
    stroke: "#1C1B1F",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M298.846 317.648C271.962 302.335 246.708 310.075 234.564 317.56C232.9 318.586 232.873 320.905 234.421 322.097C244.585 329.927 260.427 340.872 266.835 340.872C274.757 340.872 290.202 329.73 299.225 322.304C300.77 321.032 300.585 318.638 298.846 317.648Z",
    fill: "#1C1B1F"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M199.698 330.63L152.261 317.348",
    stroke: "#1C1B1F",
    strokeWidth: 15,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M196.949 358.271L154.158 361.957",
    stroke: "#1C1B1F",
    strokeWidth: 15,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M333.611 330.63L381.048 317.348",
    stroke: "#1C1B1F",
    strokeWidth: 15,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M336.36 358.271L379.15 361.957",
    stroke: "#1C1B1F",
    strokeWidth: 15,
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M265.479 333.174V379.435",
    stroke: "#1C1B1F",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M186.131 257.317C194.823 258.805 216.426 257.404 233.301 239.9",
    stroke: "#1C1B1F",
    strokeWidth: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M345.225 257.317C336.533 258.805 314.93 257.404 298.055 239.9",
    stroke: "#1C1B1F",
    strokeWidth: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFiv);
export default __webpack_public_path__ + "static/media/고질병_FIV.9ae6101b318050c7b0db412b7ee8d8a4.svg";
export { ForwardRef as ReactComponent };